/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Events_TitleInputs */



/**
* | output |
* | --- |
* | "Recorded revenue" |
*
* @param {Partner_Admin_Commission_Events_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_events_title = /** @type {((inputs?: Partner_Admin_Commission_Events_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Events_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfasste Umsätze")
	return /** @type {LocalizedString} */ ("Recorded revenue")
});